<template>
    <div class="vx-col w-full mb-base">
      <vx-card>
        <div id="data-list-list-view" class="data-list-container">
          <vs-table ref="table">
            <template slot="thead">
              <vs-th sort-key="name">Product Name</vs-th>
              <vs-th sort-key="category">Brand</vs-th>
              <vs-th sort-key="category">Price Range</vs-th>
              <vs-th sort-key="order_status">Application Status</vs-th>
              <vs-th>Action</vs-th>
            </template>

            <template>
              <tbody>
              <vs-tr v-for="(app, index) in userInfo.purchases" :key="index">
                <vs-td>
                  <p class="product-name font-medium truncate">{{app.product.product}}</p>
                </vs-td>
                <vs-td>
                  <p class="product-category">{{app.brand}}</p>
                </vs-td>
                <vs-td>
                  <p class="product-category">{{app.price_range}}</p>
                </vs-td>
                <vs-td>
                  <vs-chip :color="getOrderStatusColor(app.status)" class="product-order-status">
                    {{ app.status == '1' ? "Waiting for gurantor's approval": app.status == '2'?
                    "Waiting for showroom approval": app.status == '3'? 'In-Process': app.status == '4' ?
                    'Halt' : app.status == '5'? 'Accepted by Showroom': app.status == '6'? 'Rejected' : app.status == '7'?'Accepted by Showroom':''
                    }}
                  </vs-chip>
                  <vs-chip v-if="app.guarantors[0].status===2 || app.guarantors[0].status===3 || app.guarantors[0].status===4"  :color="getOrderStatusColorforGuarantor(app.guarantors[0].status)" class="product-order-status">
                    {{app.guarantors[0].status===2?app.guarantors[0].name+'- Accepted':''}}{{app.guarantors[0].status===3?app.guarantors[0].name+'- Rejected':''}} {{app.guarantors[0].status===4?app.guarantors[0].name+'- Information Submitted':''}}
                  </vs-chip>
                  <vs-chip v-if="app.guarantors[1].status ===2 || app.guarantors[1].status===3 || app.guarantors[1].status===4" :color="getOrderStatusColorforGuarantor(app.guarantors[1].status)" class="product-order-status">
                    {{app.guarantors[1].status===2?app.guarantors[1].name+'- Accepted':''}}{{app.guarantors[1].status===3?app.guarantors[1].name+'- Rejected':''}} {{app.guarantors[1].status===4?app.guarantors[1].name+'- Information Submitted':''}}
                  </vs-chip>
                </vs-td>

                <vs-td class="whitespace-no-wrap">
<!--                  <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"-->
<!--                                class="clickable"/>-->
<!--                  <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"-->
<!--                                class="ml-2 clickable"/>-->
                  <feather-icon icon="EyeIcon" @click="applicationDetal(app.id)" svgClasses="w-5 h-5 hover:text-success stroke-current"
                                class="ml-2 clickable"/>
                </vs-td>

              </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </div>
      </vx-card>
    </div>
</template>

<script>
  import moduleDataList from '@/store/data-list/moduleDataList.js'
  import {ME} from '../../graphql/userinfo'
  export default {
    data () {
      return {
        selected: [],
        itemsPerPage: 4,
        isMounted: false,
        userInfo: '',
        // Data Sidebar
        addNewDataSidebar: false,
        sidebarData: {},
      }
    },
    apollo: {
      user: {
        query: ME,
        manual: true,
        result ({data, loading}) {
          if (!loading) {
            this.userInfo = data.me
            console.log('Meeeeee', this.userInfo);
            this.userInfo.purchases.map(p => {
              console.log("P", p)
              if(p.status ===5){
                this.$store.dispatch('setNidDisable');
              }
              if(p.status > 6){
                this.$store.dispatch('setNidDisable');
              }
            })

          }
        }
      }
    },
    computed: {
      currentPage () {
        if (this.isMounted) {
          return this.$refs.table.currentx
        }
        return 0
      },
      products () {
        //return this.$store.state.dataList.products
      },
      queriedItems () {
        return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
      }
    },
    methods: {
      addNewData () {
        this.sidebarData = {}
        this.toggleDataSidebar(true)
      },
      deleteData (id) {
        this.$store.dispatch('dataList/removeItem', id).catch(err => {
          console.error(err)
        })
      },
      editData (data) {
        // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
        this.sidebarData = data
        this.toggleDataSidebar(true)
      },
      getOrderStatusColor (status) {
        if (status === 1) return 'rgb(155,155,155)'
        if (status === 2) return 'rgb(155,155,155)'
        if (status === 3) return 'danger'
        if (status === 4) return 'success'
        if (status === 5) return 'success'
        if (status === 6) return 'danger'
        if (status === 7) return 'success'
        return 'primary'
      },
      getOrderStatusColorforGuarantor (status) {
        if (status === 1) return 'rgb(155,155,155)'
        if (status === 2) return 'rgb(0 121 193)'
        if (status === 3) return 'danger'
        if (status === 4) return 'success'
        if (status === 5) return 'success'
        if (status === 6) return 'danger'
        return 'primary'
      },
      getPopularityColor (num) {
        if (num > 90) return 'success'
        if (num > 70) return 'primary'
        if (num >= 50) return 'warning'
        if (num < 50) return 'danger'
        return 'primary'
      },
      toggleDataSidebar (val = false) {
        this.addNewDataSidebar = val
      },
      applicationDetal(applicationId){
        this.$router.push('/applicationDetails/'+ applicationId).catch(() => {});
      }
    },
    created () {
      if (!moduleDataList.isRegistered) {
        this.$store.registerModule('dataList', moduleDataList)
        moduleDataList.isRegistered = true
      }
      this.$store.dispatch('dataList/fetchDataListItems')
    },
    mounted () {
      this.isMounted = true
    }
  }
</script>

<style lang="scss">
  .clickable {
    cursor: pointer;
  }

  img.product-img.butterfly-product {
    height: 40px;
    width: auto;
  }

  .vs-table--not-data {
    display: none;
  }

  #data-list-list-view {
    .vs-con-table {

      /*
        Below media-queries is fix for responsiveness of action buttons
        Note: If you change action buttons or layout of this page, Please remove below style
      */
      @media (max-width: 689px) {
        .vs-table--search {
          margin-left: 0;
          max-width: unset;
          width: 100%;

          .vs-table--search-input {
            width: 100%;
          }
        }
      }

      @media (max-width: 461px) {
        .items-per-page-handler {
          display: none;
        }
      }

      @media (max-width: 341px) {
        .data-list-btn-container {
          width: 100%;

          .dd-actions,
          .btn-add-new {
            width: 100%;
            margin-right: 0 !important;
          }
        }
      }

      .product-name {
        max-width: 23rem;
      }

      .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;

        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search {
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            & + i {
              left: 1rem;
            }

            &:focus + i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;

        tr {
          box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

          td {
            padding: 20px;

            &:first-child {
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }

            &:last-child {
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }

          td.td-check {
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead {
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text {
            text-transform: uppercase;
            font-weight: 600;
          }
        }

        th.td-check {
          padding: 0 15px !important;
        }

        tr {
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
</style>
